'use strict';

const Backbone = require('backbone/backbone');
const _ = require('underscore/underscore');

const YoutubePlayer = require('youtube-player');

require('./CommonGallery.less');

require('owl.carousel/src/scss/_core.scss');
require('owl.carousel/src/scss/_animate.scss');
require('owl.carousel');


module.exports = Backbone.View.extend({

    el: '.CommonGallery',

    events: {
        'click .CommonGallery-item': 'onItemClick',
        'click .CommonGallery-close': 'hide',
        'touchstart': 'onTouchStart'
    },

    initialize: function () {
        _.bindAll(this, 'onBodyClick');

        this.itemsCount = this.$('.CommonGallery-item').length;

        this.seed = (this.$el.attr('data-seed') || 2) - 0;

        if (!app.settings.isPhone) {
            this.$('.owl-carousel').removeClass('owl-carousel owl-theme');
            this.sizes = [];

            this.containerAspect = this.$el.outerHeight() / this.$el.width();
            var itemSize = 250;
            this.containerSizeW = 616;
            this.containerSizeH = this.containerSizeW * this.containerAspect;

            this.$('.CommonGallery-item').each(function (index, item) {
                var aspect = $(item).attr('data-aspect') - 0;
                var block;
                if (aspect > 1) {
                    block = {
                        aspect: aspect,
                        w: itemSize / aspect,
                        h: itemSize
                    };
                } else {
                    block = {
                        aspect: aspect,
                        w: itemSize,
                        h: itemSize * aspect
                    };
                }
                block.w /= this.containerSizeW;
                block.h /= this.containerSizeH;
                this.sizes.push(block);
            }.bind(this));
        }
    },


    onTouchStart: function (e) {
        if (app.settings.isPhone) {
            e.preventDefault();
        }
    },


    distributeItems: function () {
        var res;
        var a = 0;
        while (true) {
            res = this.distributeItemsAttempt();
            a++;
            if (a > 100000) {
                console.log('!!!');

                return;
            }

            if (res) {
                break;
            }
        }

        this.$('.CommonGallery-item').each(function (index, item) {
            var k = this.sizes[index].aspect / this.containerAspect;
            if (k > 1) {
                var width = 100 / k;
                var height = 100;
                var top = 0;
                var left = 50 * (1 - 1 / k);
                var scale = (res[index].y1 - res[index].y0);
                var tx = 50 * (2 * res[index].x0 - 1) * k + 50 + '%';
                var ty = 100 * res[index].y0 + '%';
            } else {
                var width = 100;
                var height = 100 * k;
                var top = 50 * (1 - k);
                var left = 0;
                var scale = (res[index].x1 - res[index].x0);
                var tx = 100 * res[index].x0 + '%';
                var ty = 50 * (2 * res[index].y0 - 1) / k + 50 + '%';
            }

            $(item).css({
                left: left + '%',
                top: top + '%',
                width: width + '%',
                height: height + '%',
                'transform-origin': '0 0',
                transform: 'translate3d(' + tx + ', ' + ty + ', 0) scale(' + scale + ')'
            });
        }.bind(this));
    },


    random: function () {
        var x = Math.sin(this.seed++) * 10000;

        return x - Math.floor(x);
    },


    distributeItemsAttempt: function () {
        var selected = [];

        for (var i = 0; i < this.sizes.length; i++) {
            var k = 0;
            var sizes = this.sizes[i];

            while (true) {
                k++;
                var x0 = this.random() * (1 - sizes.w);
                var y0 = this.random() * (1 - sizes.h);
                var x1 = x0 + sizes.w;
                var y1 = y0 + sizes.h;

                var i = 0;
                while (i < selected.length &&
                    (x0 >= selected[i].x1 + 0.1 ||
                        y0 >= selected[i].y1 + 0.1 ||
                        x1 <= selected[i].x0 - 0.1 ||
                        y1 <= selected[i].y0 - 0.1)) {
                    i++;
                }

                if (i === selected.length) {
                    selected.push({
                        x0: x0,
                        y0: y0,
                        x1: x1,
                        y1: y1
                    });
                    break;
                }

                if (k > 10 * (i + 1)) {
                    return;
                }
            }
        }

        selected = this.gravityToCenter(selected);

        return selected;
    },


    gravityToCenter: function (selected) {
        if (selected.length > 1) {
            var cx = 0;
            var cy = 0;

            //convert to absolutes,
            //calc mass center
            for (var i = 0; i < selected.length; i++) {
                selected[i].x0 *= this.containerSizeW;
                selected[i].x1 *= this.containerSizeW;
                selected[i].y0 *= this.containerSizeH;
                selected[i].y1 *= this.containerSizeH;
                cx += (selected[i].x0 + selected[i].x1) / 2;
                cy += (selected[i].y0 + selected[i].y1) / 2;
            }

            cx /= selected.length;
            cy /= selected.length;

            var a = 0;

            //making iters to compress blocks near mass center
            //on each iteration trying to move each block forward its vector if it is not intersecting with others
            while (true) {
                a++;
                if (a > 300) {
                    console.log('aut!');
                    break;
                }
                var wasShift = false;
                var shiftDirInd = 0;
                var lastChanceFor = -1;

                for (var i = 0; i < selected.length; i++) {
                    var icx = cx - (selected[i].x0 + selected[i].x1) / 2;
                    var icy = cy - (selected[i].y0 + selected[i].y1) / 2;
                    var len = Math.pow(icx * icx + icy * icy, 0.5);
                    var dx = 5 * icx / len;
                    var dy = 5 * icy / len;

                    //trying to move to the left or to the top
                    dx = [0, dx][shiftDirInd];
                    dy = [dy, 0][shiftDirInd];
                    shiftDirInd = 1 - shiftDirInd;

                    var x0 = selected[i].x0 + dx;
                    var x1 = selected[i].x1 + dx;
                    var y0 = selected[i].y0 + dy;
                    var y1 = selected[i].y1 + dy;

                    var j = 0;
                    while (j < selected.length &&
                        (i === j ||
                            x0 >= selected[j].x1 + (30 + j * 5) ||
                            y0 >= selected[j].y1 + (30 + j * 5) ||
                            x1 <= selected[j].x0 - (30 + j * 5) ||
                            y1 <= selected[j].y0 - (30 + j * 5))) {
                        j++;
                    }

                    if (j === selected.length) {
                        wasShift = true;
                        selected[i].x0 = x0;
                        selected[i].x1 = x1;
                        selected[i].y0 = y0;
                        selected[i].y1 = y1;
                    } else {
                        if (lastChanceFor !== i) {
                            //lets try to move the same block but to the another direction
                            //(cause we already switched it above "shiftDirInd = 1 - shiftDirInd")
                            //but only one additional attempt for every block (or we will stuck in cycle)
                            lastChanceFor = i;
                            i--;
                        }
                    }
                }

                if (!wasShift) {
                    break;
                }
            }

            //set back relative coords
            for (var i = 0; i < selected.length; i++) {
                selected[i].x0 /= this.containerSizeW;
                selected[i].x1 /= this.containerSizeW;
                selected[i].y0 /= this.containerSizeH;
                selected[i].y1 /= this.containerSizeH;
            }
        }

        //move all block to right top corner
        var maxRight = 0;
        var minTop = 1;
        for (var i = 0; i < selected.length; i++) {
            if (selected[i].y0 < minTop) {
                minTop = selected[i].y0;
            }

            if (selected[i].x1 > maxRight) {
                maxRight = selected[i].x1;
            }
        }

        if (selected.length > 1) {
            minTop -= 0.005;
            maxRight += 0.005;
        }

        for (var i = 0; i < selected.length; i++) {
            selected[i].y0 -= minTop;
            selected[i].y1 -= minTop;

            if (selected.length > 1) {
                selected[i].x0 += 1 - maxRight;
                selected[i].x1 += 1 - maxRight;
            }
        }

        return selected;
    },


    show: function () {
        if (!this.isInitiated) {
            this.$('source').each(function () {
                var srcset = this.getAttribute('data-srcset');
                var sizes = this.getAttribute('data-sizes');
                srcset && this.setAttribute('srcset', srcset);
                sizes && this.setAttribute('sizes', sizes);
            });

            this.$('img, video').each(function () {
                var src = this.getAttribute('data-src');
                src && this.setAttribute('src', src);
                this.load && this.load();
            });

            this.$('.CommonGallery-item-youtube').each(function (index, item) {
                var player = new YoutubePlayer($(item).find('div')[0], {
                    videoId: $(item).attr('data-id'),
                    playerVars: {
                        'autoplay': 0,
                        'controls': 1,
                        'autohide': 1,
                        'start': ($(item).attr('data-time') || 0) - 0,
                        'wmode': 'opaque'
                    }
                });

                $(item).data('player', player);
            });
        }

        if (!app.settings.isPhone) {
            clearTimeout(this.showTimeout);
            clearTimeout(this.autoplayTimeout);
            this.showTimeout = setTimeout(function () {
                if (!this.isInitiated) {
                    this.distributeItems();
                    this.$el.css('display', 'none');
                    this.$el.outerHeight();
                    this.$el.css('display', '');
                }
                this.$el.removeClass('hidden');
                this.isInitiated = true;

                if (this.itemsCount === 1) {
                    this.$prevItem = this.$('.CommonGallery-item');
                    this.autoplayTimeout = setTimeout(function () {
                        this.startMedia(this.$prevItem);
                    }.bind(this), 300);
                }
            }.bind(this), 300);
        } else {
            if (!this.isInitiated) {
                this.$('.owl-carousel').owlCarousel({
                    stagePadding: 0,
                    items: 1,
                    margin: 0,
                    singleItem: true,
                    loop: true,
                    dots: true,
                    touchDrag: this.itemsCount > 1
                });

                this.$('.CommonGallery-left, .CommonGallery-right').toggleClass('hidden', this.itemsCount < 2);

                this.$('.owl-carousel').on('change.owl.carousel', function () {
                    this.stopMedia(this.$prevItem);
                }.bind(this));
                this.$('.owl-carousel').on('changed.owl.carousel', function (e) {
                    this.$('.CommonGallery-left, .CommonGallery-right').addClass('hidden');
                    this.$prevItem = this.$('.owl-item').eq(e.item.index)
                        .find('.CommonGallery-item');
                    this.startMedia(this.$prevItem);
                }.bind(this));
            }
            this.$el.removeClass('hidden');
            this.isInitiated = true;
            this.$prevItem = this.$('.owl-item.active .CommonGallery-item').eq(0);
            this.startMedia(this.$prevItem);
        }
    },

    hide: function () {
        clearTimeout(this.showTimeout);
        clearTimeout(this.autoplayTimeout);
        this.closePrevious();
        this.$el.addClass('hidden');
    },

    startMedia: function ($item) {
        if (!$item) {
            return;
        }

        if ($item.attr('data-tp') === 'video') {
            $item.find('video')
                .prop('controls', true)[0]
                .play();
        }
        if ($item.attr('data-tp') === 'youtube' && !app.settings.isPhone) {
            $item.find('.CommonGallery-item-youtube').data('player')
                .playVideo();
        }
    },

    stopMedia: function ($item) {
        if (!$item) {
            return;
        }

        if ($item.attr('data-tp') === 'video') {
            $item.find('video')
                .prop('controls', false)[0]
                .pause();
        }
        if ($item.attr('data-tp') === 'youtube') {
            $item.find('.CommonGallery-item-youtube').data('player')
                .pauseVideo();
        }
    },

    closePrevious: function () {
        clearTimeout(this.autoplayTimeout);

        if (this.itemsCount <= 1) {
            this.stopMedia(this.$prevItem);

            return;
        }

        if (this.$prevItem) {
            this.$prevItem.removeClass('expanded');
            this.stopMedia(this.$prevItem);
        }

        $('body').off('click', this.onBodyClick);
        delete this.$prevItem;
    },

    onItemClick: function (e) {
        if (app.settings.isPhone) {
            return;
        }

        if (this.itemsCount <= 1) {
            return;
        }

        var $item = $(e.currentTarget);

        if ($item.hasClass('expanded') && $item.attr('data-tp') !== 'image') {
            return;
        }

        if (this.$prevItem) {
            this.closePrevious();
            delete this.$prevItem;

            return;
        }

        this.$prevItem = $item;
        $('body').on('click', this.onBodyClick);

        $item.addClass('expanded');

        clearTimeout(this.autoplayTimeout);
        this.autoplayTimeout = setTimeout(function () {
            this.startMedia($item);
        }.bind(this), 300);
    },

    onBodyClick: function (e) {
        if (this.itemsCount <= 1) {
            return;
        }

        if ($(e.target).closest('.CommonGallery-item').length) {
            return;
        }

        if ($(e.target).closest('a').length) {
            return;
        }

        this.closePrevious();
    },

    hasOpenedItems: function () {
        return !!this.$prevItem && this.itemsCount > 1;
    }

});
